import React from 'react'
import MaterialSymbol from '../material-symbol'

const Undo = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="undo" {...props} />
))

Undo.displayName = 'Undo'

export default Undo
